import service from 'chimera/all/store/service'

export default service
